module.exports = __webpack_public_path__ + "img/stock1.f8c37a9e.png";